import React from 'react';
import { AssetUrls } from 'config/assets';
import './EliteBadge.css';

interface EliteBadgeProps {
  isElite: boolean;
  size?: number;
  className?: string;
}

const EliteBadge: React.FC<EliteBadgeProps> = ({ isElite, size = 16, className }) => {
  if (!isElite) return null;

  return (
    <img
      src={AssetUrls.icons.elite.badge}
      alt="Elite"
      title="TradeMagic Elite member"
      width={size}
      height={size}
      className={`elite-badge ${className || ''}`}
    />
  );
};

export default EliteBadge;
